import SvgUndrawNoData from "../svgs/undraw/no-data";
import style from "./style.module.scss";

export enum iconSizeEnum {
    small = 'small',
    medium = 'medium',
    large = 'large',
}

type NoDataType = {
    text?: string;
    icon?: any;
    iconSize?: iconSizeEnum
}

const NoData = ({text, icon = <SvgUndrawNoData />, iconSize = iconSizeEnum.small}: NoDataType) => {
    return (
        <div className={style.cNoData}>
            <div className={`${style[`cNoData__icon`]} ${style[`cNoData__icon__${iconSize}`]}`}>
                {icon}
            </div>
            {text && <p>{text}</p>}
        </div>
    );
};

export default NoData;